module.exports = __webpack_public_path__ + "static/gallery4-990b2f04e2c2ccc9ea9bf6c6ebebe60c.jpg";